import { render, staticRenderFns } from "./UserSettingsDlg.vue?vue&type=template&id=2b651256&"
import script from "./UserSettingsDlg.vue?vue&type=script&lang=js&"
export * from "./UserSettingsDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports